import { useParams, useSearchParams } from 'react-router-dom';
import { Title } from 'src/viewLayer/components/DesignSystem';
import TextWithInterpolation from 'src/viewLayer/components/shared/TextWithInterpolation/index';
import { shuffle } from 'src/viewLayer/helpers/shuffle';
import { BackButton } from 'src/viewLayer/components/shared/BackButton/index';
import { t } from 'src/viewLayer/helpers/translations';
import { trackQuestionAsked } from 'src/dataLayer/remoteData/babbelEventStream';
import type { QuestionNodePropType } from './types';
import { Answers } from 'src/viewLayer/components/nodes/QuestionNode/Answers';
import { QuestionNodeContainer, Tagline, TitleContainer } from './index.styled';

export default ({
  nodeConfig,
  goToNextNode,
  userInput,
  setUserInput
}: QuestionNodePropType): JSX.Element => {
  const pathParams = useParams();
  const [queryParams] = useSearchParams();

  const { name, question, answers, icons, options } = nodeConfig;
  const { learnLang } = pathParams;

  trackQuestionAsked({
    learnLang,
    question: question.babbel_tracking,
    answerPresentationId: question.answer_presentation_id
  });

  const taglineKey = question.tagline_interpolated || question.tagline;
  const answersArray = options?.shuffle ? shuffle({ items: answers, shuffleOptions: options.shuffle }) : answers;

  const clickHandlerProps = {
    setUserInput,
    userInput,
    name,
    question,
    options,
    goToNextNode,
    learnLang,
    pathParams,
    queryParams
  };

  return (
    <QuestionNodeContainer id={`uat-${name}`} className="QuestionNode" alignItems="center">
      <TitleContainer align="spaceBetween">
        { options?.showBackButton && <BackButton/> }
        <Title size={{ xxxsmall: 'small', medium: 'default' }} textAlign="center">
          <TextWithInterpolation translationText={t(question.i18n_key)} />
        </Title>
      </TitleContainer>
      {
        taglineKey &&
        <Tagline className="tagline">
          <TextWithInterpolation translationText={ t(taglineKey) } />
        </Tagline>
      }
      <Answers
        answersArray={ answersArray }
        clickHandlerProps={ clickHandlerProps }
        icons={ icons }
      />
    </QuestionNodeContainer>
  );
};
